/*
 * File: InstructorNotesSkeleton.tsx
 * Author: Austin Robinson
 * Date Created: 12/07/2025
 * Copyright (c) DrivingDoc 2025
 */
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';

/**
 * Skeleton loader for InstructorNotes component
 * Mirrors the structure of the notes section
 */
export default function InstructorNotesSkeleton() {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        bgcolor: 'grey.50',
        borderRadius: 2,
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
        <Typography variant="subtitle2" fontWeight="bold">
          <Skeleton width={180} />
        </Typography>
        <Skeleton width={110} height={32} variant="rounded" />
      </Box>

      <Skeleton width="100%" height={120} variant="rounded" sx={{ bgcolor: 'white' }} />

      <Skeleton width={100} height={16} sx={{ mt: 0.5 }} />
    </Paper>
  );
}
